import { get, some } from 'lodash';

function someInNetworkReferrals(services) {
  return some(services, (service) => (
    !get(service, 'refer_to_outside_network.value', '')
  ));
}

export default someInNetworkReferrals;
